<template>
  <v-row>
    <v-col>
      <v-card class="py-3" :class="{ 'px-6': $vuetify.breakpoint.smAndUp }">
        <v-data-table
          :headers="header"
          :items="DataTable"
          hide-default-footer
          class="elevation-1 fix-font"
          mobile-breakpoint="0"
          :items-per-page="-1"
        >
          <template v-slot:top> </template>
          <template v-slot:item.payDate="{ item }">
            {{ $dateFormatByLang(item.payDate) }}
          </template>
          <template v-slot:footer>
            <slot name="footer"></slot>
          </template>
        </v-data-table>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: ['header', 'DataTable']
}
</script>

<style scoped>
.fix-font {
  white-space: nowrap;
}
</style>
